import { Form, InputGroup as InputGroupC } from "react-bootstrap";


export function InputGroup({
    type,
    value,
    label,
    placeholder,
    name,
    error,
    touched,
    onChangeMethod,
    onBlurMethod,
    maxLength,
    disabled,
    readonly,
    className,
    required,
    autocomplete,
    autosave,
    max,
    left,
    right
}: {
    type: string;
    value: string | string[] | number;
    label?: string;
    placeholder?: string;
    name: string;
    error?: string;
    touched?: boolean;
    onChangeMethod?: any;
    onBlurMethod?: any;
    maxLength?: number;
    disabled?: boolean;
    readonly?: boolean;
    className?: string;
    required?: boolean;
    autocomplete?: string
    autosave?: string
    max?: string | number;
    left?: any;
    right?: any;
}) {

    return (
        <>
            <Form.Group className="mb-3 position-relative">
                {
                    label && 
                    <Form.Label htmlFor={name}>
                        {label} {required && <span className="text-danger">*</span>}
                    </Form.Label>
                }
                <InputGroupC>
                    {left && <InputGroupC.Text className="rounded-start"><div className=" max-group">{left}</div></InputGroupC.Text>}
                    <Form.Control
                        type={type}
                        id={name}
                        name={name}
                        value={value}
                        placeholder={placeholder}
                        onChange={onChangeMethod}
                        onBlur={onBlurMethod}
                        isInvalid={!!error && (touched)}
                        className={className + (left && " rounded-end ")}
                        disabled={disabled}
                        readOnly={readonly}
                        maxLength={maxLength}
                        autoComplete={autocomplete}
                        autoSave={autosave}
                        onCopy={(e) => e.preventDefault()}
                        max={max}
                        aria-describedby="basic-addon1"
                    />
                    {right && <InputGroupC.Text className="rounded-end max-group">{right}</InputGroupC.Text>}
                    <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>
                </InputGroupC>
            </Form.Group>
        </>
    );
}